// This mixins can be used outside the context of my-pages-container.vue
export const mixinExternal = {
  computed: {
    isMyPages() {
      return window.location.href.includes(this.clientModel.myPageUrl)
    }
  },
  methods: {
    handleExternalMyPagesNavigation(url) {
      window.location.href = url
      if(this.isMyPages) setTimeout(() => window.location.reload(), 150)
    }
  }
}

// This mixins can ONLY be used inside the context of my-pages-container.vue
const mixinInternal = {
  inject: ['navigationOptions', 'navigationHistory'],
  methods: {
    goToSubPage(component) {
      this.publish('my-pages-set-active-component', component)
    },
    goBack() {
      this.publish('my-pages-go-back')
    }
  }
}

export default mixinInternal
